export default __webpack_public_path__ + "static/media/0.f8f8c3ff.svg";